// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

const state = {

    installableApp : false,
    installEvent   : null
};

const mutations = {

    toggleInstallable( state, event = null ){

        state.installableApp = !state.installableApp;
        state.installEvent = event;
    },
    installWebapp( state ){

        if( !state.installEvent ){

            console.log( 'no install event' );
        } else {

            console.log( 'yes install event: ', state.installEvent );
            state.installEvent.prompt();

            state.installEvent.userChoice
                .then( function( result ){

                    if ( result.outcome === 'accepted' ) {

                        console.log( 'User accepted the A2HS prompt' );
                    } else {

                        console.log( 'User dismissed the A2HS prompt' );
                    }
                    state.installEvent = null;
                    state.installableApp = false;
                });
        }
    }
};

const actions = {

    installWebapp( { commit } ){

        console.log( 'hello within pwa vuex' );
        commit( 'installWebapp' );
    },
    toggleInstallable( { commit }, event ){

        commit( 'toggleInstallable', event );
    }
};

const getters = {

    installableApp : state => state.installableApp
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};